import { fallback, picklist } from "valibot"

export const PowerPreferenceSchema = fallback(picklist([
  'high-performance',
  'low-power',
  'default',
]), 'default')
